import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	getArtistRoyaltyRevenueContributions,
	getArtistRoyaltyRevenueDetail,
	getContributorArtists,
	getContributors,
	saveContributor,
	saveContributorArtist,
	updateArtistRoyaltyRevenue,
	updateContributorProfile,
} from "services/contributor.service";
import { initGlobalState } from "./default";
import { ContributorType, RevenueDetailType, RevenueType } from "../../common/type";
import { message } from "antd";

const globalSlice = createSlice({
	name: "global",
	initialState: initGlobalState,
	reducers: {
		toggleMiniAddContributorModal: (
			state,
			action: PayloadAction<boolean | number>
		) => {
			state.addMiniContributorModal = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder

			// Contributors list
			.addCase(getContributors.pending, (state) => {
				state.getContributorLoading = true;
			})
			.addCase(getContributors.fulfilled, (state, action) => {
				state.getContributorLoading = false;
				state.contributors = action.payload;
			})
			.addCase(getContributors.rejected, (state, action) => {
				state.getContributorLoading = false;
			})

			// Contributor artists list
			.addCase(getContributorArtists.pending, (state) => {
				state.getContributorArtistLoading = true;
			})
			.addCase(getContributorArtists.fulfilled, (state, action) => {
				state.getContributorArtistLoading = false;
				state.contributorArtists = action.payload;
			})
			.addCase(getContributorArtists.rejected, (state, action) => {
				state.getContributorArtistLoading = false;
			})

			// Get-artist-royalty-revenue-detail
			.addCase(getArtistRoyaltyRevenueDetail.pending, (state) => {
				state.artistRoyaltyRevenueDetailLoading = true;
				state.artistRoyaltyRevenueDetail = {}
			})
			.addCase(
				getArtistRoyaltyRevenueDetail.fulfilled,
				(state, action: PayloadAction<RevenueDetailType>) => {
					state.artistRoyaltyRevenueDetailLoading = false;
					state.artistRoyaltyRevenueDetail = action.payload;
				}
			)
			.addCase(getArtistRoyaltyRevenueDetail.rejected, (state, action) => {
				state.artistRoyaltyRevenueDetailLoading = false;
				state.artistRoyaltyRevenueDetail = {}
			})

			// Update-artist-royalty-revenue
			.addCase(updateArtistRoyaltyRevenue.pending, (state) => {
				state.updateArtistRoyaltyRevenueLoading = true;
			})
			.addCase(
				updateArtistRoyaltyRevenue.fulfilled,
				(state, action: PayloadAction<RevenueType>) => {
					state.updateArtistRoyaltyRevenueLoading = false;
					// message.success("Record updated successfully");
					state.artistRoyaltyRevenueDetail = action.payload;
					const index = state.allArtistRoyaltyRevenue.findIndex(
						(item) => item.id == action.payload.id
					);
					if (index > -1) {
						state.allArtistRoyaltyRevenue[index] = action.payload;
					}
				}
			)
			.addCase(updateArtistRoyaltyRevenue.rejected, (state, action) => {
				state.updateArtistRoyaltyRevenueLoading = false;
			})

			// List-artist-royalty-revenues
			.addCase(getArtistRoyaltyRevenueContributions.pending, (state) => {
				state.artistRoyaltyRevenueContributionsLoading = true;
			})
			.addCase(getArtistRoyaltyRevenueContributions.fulfilled, (state, action) => {
				state.artistRoyaltyRevenueContributionsLoading = false;
				state.artistRoyaltyRevenueContributions = action.payload;
			})
			.addCase(getArtistRoyaltyRevenueContributions.rejected, (state, action) => {
				state.artistRoyaltyRevenueContributionsLoading = false;
			})

			// Save Contributor
			.addCase(saveContributor.pending, (state) => {
				state.saveContributorLoading = true;
			})
			.addCase(
				saveContributor.fulfilled,
				(state, action: PayloadAction<ContributorType>) => {
					const testD: ContributorType = action.payload;
					state.saveContributorLoading = false;
					state.contributors.unshift(testD);
				}
			)
			.addCase(saveContributor.rejected, (state, action) => {
				state.saveContributorLoading = false;
			})
		
		// Save Contributor Artist
		.addCase(saveContributorArtist.pending, (state) => {
			state.saveContributorArtistLoading = true;
		})
		.addCase(
			saveContributorArtist.fulfilled,
			(state, action) => {
				console.log('action.payload', action.payload);
				state.saveContributorArtistLoading = false;
			}
		)
		.addCase(saveContributorArtist.rejected, (state, action) => {
			state.saveContributorArtistLoading = false;
		})

	},
});

export const { toggleMiniAddContributorModal } = globalSlice.actions;

export default globalSlice.reducer;
